import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'
import { ITrainingGroup } from '../../interfaces'

const getSortTrainingGroupsMutationRequest = () => ({
  method: 'put',
  url: `${config.baseUrl}/TrainingGroups/sort`,
})

const useSortTrainingGroupsMutation = (options = {}) => {
  const request = useMemo(() => getSortTrainingGroupsMutationRequest(), [])

  const sortTrainingGroups = useCallback(
    async (data: ITrainingGroup) => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ITrainingGroup, Error, ITrainingGroup>(sortTrainingGroups, options)

  return response
}

export default useSortTrainingGroupsMutation